module.exports = __webpack_public_path__ + "static/media/ethereum_qr.8f4b48a0.png";